import { ImSpinner8 } from 'react-icons/im';

export default function CircularProgress({ className, component = 'pequeno', size }) {
  const elementos = [
    { name: 'grande', classes: 'w-11 h-11 relative text-primary-main' },
    { name: 'pequeno', classes: 'w-5 h-5 relative text-primary-main' },
    { name: 'padrao', classes: 'relative ' },
  ];
  return (
    <>
      <ImSpinner8
        size={size}
        className={`animate-spin ${elementos.find(e => e.name == component)?.classes} ${className}`}
        role="status"
        aria-label="loading"
      />
      <span className="sr-only">Loading...</span>
    </>
  );
}
